var map = {
	"./google-play-badge-da-DK.svg": 83175,
	"./google-play-badge-de-DE.svg": 8725,
	"./google-play-badge-en-GB.svg": 76375,
	"./google-play-badge-en-US.svg": 42720,
	"./google-play-badge-es-ES.svg": 68919,
	"./google-play-badge-es-MX.svg": 77156,
	"./google-play-badge-fr-FR.svg": 94283,
	"./google-play-badge-it-IT.svg": 93277,
	"./google-play-badge-nb-NO.svg": 84934,
	"./google-play-badge-nl-NL.svg": 69699,
	"./google-play-badge-pl-PL.svg": 24647,
	"./google-play-badge-pt-BR.svg": 76647,
	"./google-play-badge-pt-PT.svg": 76023,
	"./google-play-badge-sv-SE.svg": 57254
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31724;